import { lazy, Suspense } from 'react';

const LazyMemberList = lazy(() => import('./MemberList'));

const MemberList = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => (
  <Suspense fallback={null}>
    <LazyMemberList {...props} />
  </Suspense>
);

export default MemberList;
